/**
 * traces analyze — coming soon
 *
 * WHY NOT WIRED: No BE endpoint for per-prompt trace analysis yet.
 * The BE has GET /api/traces/analytics (workspace-level) but not per-prompt.
 * SDK does not expose analyzeTraces().
 *
 * WHEN TO WIRE: Once the BE adds a per-prompt analysis endpoint and the
 * SDK is regenerated with the method, replace the guard below with a real
 * client.analyzeTraces(promptId) call.
 */

import { Command } from 'commander';
import chalk from 'chalk';
import { getJsonFlag } from '../../lib/output.js';
import { getAppBaseUrl } from '../../lib/ui-links.js';

export function registerAnalyzeCommand(parent: Command): void {
  parent
    .command('analyze')
    .description('Analyze traces for a prompt (coming soon)')
    .argument('<prompt-id>', 'Prompt ID')
    .addHelpText('after', `
Examples:
  ${chalk.dim('$')} mutagent traces analyze <prompt-id>
  ${chalk.dim('$')} mutagent traces analyze <prompt-id> --json

${chalk.dim('Aggregates trace data for a prompt: avg latency, token usage, error rates.')}
${chalk.yellow('NOTE: This command is not yet connected to the API.')}
    `)
    .action((promptId: string) => {
      const isJson = getJsonFlag(parent);

      if (isJson) {
        console.log(JSON.stringify({
          status: 'coming_soon',
          promptId,
          message: 'Per-prompt trace analysis is not yet available. Use the dashboard at /observe/analytics for workspace-level metrics.',
        }));
      } else {
        console.log(chalk.yellow(`\n  ⚠  Per-prompt trace analysis for ${promptId} is not yet available — coming soon.\n`));
        console.log(chalk.dim('  Workspace-level analytics are available on the dashboard:'));
        console.log(chalk.dim(`  ${getAppBaseUrl()}/observe/analytics\n`));
      }
    });
}
